import { array, type InferOutput } from 'valibot'
import { ActionLogSchema } from './ActionLog.type'
// import Action from './action/Action.type'

export const ActionLogListSchema = array(ActionLogSchema)

export type ActionLogList = InferOutput<typeof ActionLogListSchema>
